<script lang="ts">
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../_common/z/zinput.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import type { Referral } from '../../modules/eventsApi/referrals/referral'

    export let referral: Referral

    function removeItem() {
        referral = null
    }
</script>

{#if referral}
    <ZContainer class="mt-2" gapRow="8px" gapCol="8px">
        <Zinput size={6} sizeM={12} label="Origem" type="text" bind:value={referral.label} />
        <ZContainerCol size={1} sizeM={12}>
            {#if !referral.referralId}
                <Zbutton color="red" icon={faTrash} on:click={removeItem} />
            {/if}
        </ZContainerCol>
    </ZContainer>
{/if}
